var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUserImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 20,
    fill: "#E8EAEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#F2F3F5",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.29,
    cx: 22,
    cy: 22,
    r: 19.5,
    stroke: "#808297"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.0999C19.276 21.0999 18.724 16.9719 18.724 16.9719C18.4 14.8239 19.384 12.3999 21.964 12.3999C24.556 12.3999 25.54 14.8239 25.216 16.9719C25.216 16.9719 24.724 21.0999 22 21.0999ZM22 24.1839L25.264 21.9999C28.132 21.9999 30.688 24.7959 30.688 27.4359V30.4239C30.688 30.4239 26.308 31.7799 22 31.7799C17.62 31.7799 13.312 30.4239 13.312 30.4239V27.4359C13.312 24.7359 15.64 22.0599 18.676 22.0599L22 24.1839Z",
    fill: "#C2C3CD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserImage);
export default __webpack_public_path__ + "static/media/DefaultUserImage.b011ea5dafe798841be30dbb5bd33ffb.svg";
export { ForwardRef as ReactComponent };